import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqData } from '../data/mock';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200 last:border-b-0">
      <button
        onClick={onClick}
        className="w-full py-5 flex items-center justify-between text-left hover:text-sage-600 transition-colors duration-300"
      >
        <span className="text-lg font-medium text-gray-900 pr-4">{question}</span>
        <ChevronDown
          size={24}
          className={`text-sage-600 flex-shrink-0 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-5' : 'max-h-0'
        }`}
      >
        <p className="text-gray-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-stone-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-sage-600 text-sm font-medium tracking-wider mb-2">FAQ</p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
            Često postavljana pitanja
          </h2>
        </div>

        {/* FAQ List */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
          {faqData.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => toggleFAQ(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;